/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    className: PropTypes.string,
};

const FacebookIcon = ({ color = '#222', backgroundColor = '#FFF', className = null }) => (
    <svg
        width="34.18px"
        height="34.18px"
        viewBox="0 0 34.18 34.18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <rect fill={color} x="5.45" y="3.58" width="25.3" height="30.6" />
        <path
            fill={backgroundColor}
            d="M31.65,0H2.53C1.13,0,0,1.1,0,2.45v29.28c0,1.35,1.13,2.45,2.53,2.45h13.78c-.12-.02-.24-.03-.36-.05v-12.72h-4.51v-5.05h4.51v-3.97c0-4.51,2.89-7.04,7.04-7.04,1.26,0,2.71.18,3.97.36v4.6h-2.35c-2.17,0-2.71,1.08-2.71,2.53v3.52h4.78l-.81,5.05h-3.97v12.72c-.12.02-.24.03-.36.05h10.1c1.4,0,2.53-1.1,2.53-2.45V2.45c0-1.35-1.13-2.45-2.53-2.45Z"
        />
    </svg>
);

FacebookIcon.propTypes = propTypes;

export default FacebookIcon;
